module.exports = __webpack_public_path__ + "assets/img/25_387.cea94cec.jpg";